export default __webpack_public_path__ + "4cf97eff664151d4c6f3fa46baf1abf1.png";